import { connect } from 'react-redux'
import Roles from 'modules/Roles/index'
import instSelector from 'modules/Roles/selectors'
import authSelector from 'modules/Auth/selectors'

import {
  getRolesListData,
  updateRoleData,
  setJobId,
  getJobDetails,
  corporateAboutUs,
  getCities,
  updatePageNum,
  jobSharingEmail,
  getUserCorpList,
  
} from 'modules/Roles/actions'
import {  getNotificationCatalogues,
  sendNotificationEmail,
  sendNotificationBulkEmail
} from 'modules/Students/actions'
import Settingselectors from 'modules/Settings/selectors'

const mapStateToProps = state => ({
  rolesList: instSelector.getRolesList(state),
  singleRoleDetails: instSelector.getJobDetails(state),
  instituteCampusId: state.auth.instituteDetails.id,
  citiesList: instSelector.getCities(state),
  corporateDetails: instSelector.getCorpDetails(state),
  pageNum: instSelector.getPageNum(state),
  permissions : authSelector.getUserPermissions(state),
  instituteData: Settingselectors.getInstituteData(state),
})

const mapDispatchToProps = {
  getRolesListData,
  updateRoleData,
  setJobId,
  getJobDetails,
  corporateAboutUs,
  getCities,
  updatePageNum,
  jobSharingEmail,
  getNotificationCatalogues,
  sendNotificationEmail,
  getUserCorpList,
  sendNotificationBulkEmail
  
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles)
